<template>
  <div>
    <div class="tw-mb-8">
      <h1>{{ $t('adm.logs.audit.title') }}</h1>
    </div>
    <AuditLogsFilters class="tw-mb-4" />

    <div v-loading="isLoading">
      <LogsTable
        :data="logs"
        :on-sort-change="sortChange"
      />
      <AdministrationTablePagination
        store-path="v2/admin/cms/logs/audit"
        filter-relative-path="filters"
        class="tw-mt-6"
      />
    </div>

    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AuditLogsFilters from '@/components/Administration/Logs/Audit/AuditLogsFilters.vue';
import LogsTable from '@/components/shared/AuditLogTable/LogsTable.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'AuditLogV2',
  components: {
    LogsTable,
    AdministrationTablePagination,
    ForeignersMessagingPopover,
    AuditLogsFilters,
  },
  data() {
    return {
      isAddDocumentsDialogOpen: false,
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.logs.audit.filters,
      isLoading: (state) => state.v2.admin.cms.logs.audit.isLoading,
      logs: (state) => state.v2.admin.cms.logs.audit.logs,
    }),
    ...mapGetters({
      isAuditSeveritiesEmpty: 'v2/shared/enums/isAuditSeveritiesEmpty',
      clientsUsersAreEmpty: 'v2/admin/cms/clients/users/selectOptionsAreEmpty',
      internalUsersAreEmpty: 'v2/admin/cms/internal/users/selectOptionsAreEmpty',
    }),
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();

    if (this.clientsUsersAreEmpty) {
      this.$store.dispatch('v2/admin/cms/clients/users/loadAllUsers');
    }
    if (this.internalUsersAreEmpty) {
      this.$store.dispatch('v2/admin/cms/internal/users/loadAllUsers');
    }

    this.$store.dispatch('v2/shared/enums/loadAdminAuditEvents');
    if (this.isAuditSeveritiesEmpty) {
      this.$store.dispatch('v2/shared/enums/loadAuditSeverities');
    }
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/logs/audit/load');
    },
    sortChange({ prop, order }) {
      const payload = order ? `${order === 'descending' ? '-' : ''}${prop}` : '-action_date';

      this.$store.commit('v2/admin/cms/logs/audit/updateFilter', { field: 'order_by', payload });
    },
  },
};
</script>
